module.exports = __webpack_public_path__ + "static/uv-texture@2x-84ac407137cf6dd18990c0b57ab9ee12.jpg";